<template>
  <input type="file" accept="image/*" ref="pinturainput" :id="photoId" />
</template>
<script>
// Import Pintura
import { openDefaultEditor } from '@pqina/pintura';

export default {
  name: 'pintura-input-wrapper',
  props: {
    photoId: {
      type: Number,
      reqired: true,
    },
    pinturaOpts: {
      type: Object,
      default() { return {}; },
    }
  },
  mounted() {
    // Largely a tiny Vue wrapper around https://pqina.nl/pintura/docs/v8/getting-started/examples/use-with-file-input/
    // get a reference to our file input element
    const fileInput = this.$refs.pinturainput;

    // wait for the change event to fire
    fileInput.addEventListener('change', () => {
      // no files selected
      if (!fileInput.files.length) return;

      this.pinturaOpts.src = fileInput.files[0]
      // edit the selected file
      const editor = openDefaultEditor(this.pinturaOpts);
      // store the resulting file in the file input
      editor.on('process', ({ dest }) => {
        // create a files list
        this.$emit('photo-added', dest, this.photoId);
      });
    });
  }
};
</script>
